<template>
  <div class="step-input-selector justify-content-around">
    <div
      class="step-input mb-2 d-flex align-items-center justify-content-center"
      data-toggle="tooltip"
      :title="list.name"
      data-placement="top"
      :class="[
        { selected: index == doneIndex - 1},
        { current: index == doneIndex - 1 },
        { 'mr-1': index < stepLists.length - 1 },
        { once: list['label'] },
      ]"
      v-for="(list, index) in stepLists"
      :key="index"
      @click.prevent="addSelectedSteps(index)"
      :disabled="disabled"
    ><span class="bprobability">{{ list.name }}</span>
		<span class="hprobability">{{ numberWithCurrencySymbol(list.probability) }}</span>
      
    </div>
  </div>
</template>

<script>
import {numberWithCurrencySymbol} from "@app/Helpers/helpers";
export default {
  name: "StepInputSelector",
  props: {
    showLabel: {
      type: Boolean,
      default: false,
    },
    stepLists: {
      type: Array,
    },
    stepComplete: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
		numberWithCurrencySymbol,
      doneIndex: -1,
    };
  },
  mounted() {
    setTimeout(function () {
      $('[data-toggle="tooltip"]').tooltip();
    }, 6000);
    this.doneIndex =
      this.$props.stepComplete != undefined
        ? this.$props.stepComplete + 1
        : this.doneIndex;
    //for default first stage selected
    if(this.$props.stepComplete == undefined){
      this.addSelectedSteps(0);
    }
  },
  methods: {
    addSelectedSteps(index) {
      if (index + 1 != this.doneIndex && !this.disabled) {
        this.doneIndex = index + 1;
        this.$emit("stepChanges", index);
      }
    },
  },
};
</script>
<style scoped>
.step-input{
  overflow:hidden;
}
.step-input > span{
  text-indent:0.95em;
}
.selected {
  background: blue;
  color: #fff;
}
.once {
  
}
</style>
